<template>
  <div>
    <div class="tw-bg-white tw-shadow tw-border-t tw-border-gray-200">
      <base-content class="tw-pt-3 tw-pb-3.5">
        <base-breadcrumbs :breadcrumbs="breadcrumbs" />
      </base-content>
      <base-content class="tw-flex tw-justify-between tw-items-center tw-pt-0">
        <h1 class="tw-text-xl sm:tw-text-2xl tw-leading-tight tw-text-gray-900 tw-mb-0 tw-font-thin tw-my-auto">Activity Types</h1>
        <base-button @click="add" class="tw-hidden sm:tw-flex">
          <template v-slot:icon>
            <plus-icon />
          </template>
          New Activity Type
        </base-button>
        <base-icon @click="add" class="tw-inline sm:tw-hidden">
          <plus-icon class="tw-h-5 tw-w-5" />
        </base-icon>
      </base-content>
    </div>
    <base-content>
      <div class="tw-font-light tw-mb-2.5">Custom Types</div>
      <base-table class="tw-mb-6" :loading="isLoading" :fields="fields" :items="customItems">
        <template #activityType="{item: todoItemType}">
          <div class="tw-flex-col tw-items-center  tw-whitespace-nowrap">
            <div class="tw-my-auto">
              {{ todoItemType.label }}<base-badge v-if="todoItemType.isSystemManaged === true" color="yellow" size="sm" class="tw-ml-2">System Managed</base-badge>
            </div>
            <div class="tw-text-xs tw-text-gray-600 tw-mt-1">{{ todoItemType.description }}</div>
          </div>
        </template>

        <template #actions="{item: todoItemType}">
          <div class="tw-flex tw-justify-center tw-space-x-1">
            <base-button type="flat" size="sm" @click="edit(todoItemType)">
              <template v-slot:icon>
                <edit-icon />
              </template>
              Edit
            </base-button>
            <base-button :disabled="todoItemType.isSystemManaged === true" type="flat" size="sm" @click="del(todoItemType.todoItemTypeId)">
              <template v-slot:icon>
                <trash-icon />
              </template>
              Delete
            </base-button>
          </div>
        </template>
        <template #empty-state>
          <div class="tw-flex tw-justify-center tw-py-5">
            No Results
          </div>
        </template>
        <template #loading-row>
          <td class="tw-py-3 tw-px-2">
            <base-skeleton-loader class="tw-h-4 tw-w-48 tw-mb-3" />
            <base-skeleton-loader class="tw-h-3 tw-w-100" />
          </td>
          <td class="tw-py-3 tw-px-4">
            <div class="tw-flex tw-space-x-2 tw-justify-center">
              <base-skeleton-loader class="tw-h-8 tw-w-20" v-for="key in 2" :key="`action-loader-cell-${key}`" />
            </div>
          </td>
        </template>
      </base-table>
      <div class="tw-font-light tw-mb-2.5">System Types</div>
      <base-table :loading="isLoading" :fields="fields" :items="systemItems">
        <template #activityType="{item: todoItemType}">
          <div class="tw-flex-col tw-items-center  tw-whitespace-nowrap">
            <div class="tw-my-auto">
              {{ todoItemType.label }}<base-badge v-if="todoItemType.isSystemManaged === true" color="yellow" size="sm" class="tw-ml-2">System Managed</base-badge>
            </div>
            <div class="tw-text-xs tw-text-gray-600 tw-mt-1">{{ todoItemType.description }}</div>
          </div>
        </template>

        <template #actions="{item: todoItemType}">
          <div class="tw-flex tw-justify-center tw-space-x-1">
            <base-button type="flat" size="sm" @click="edit(todoItemType)">
              <template v-slot:icon>
                <edit-icon />
              </template>
              Edit
            </base-button>
          </div>
        </template>
        <template #empty-state>
          <div class="tw-flex tw-justify-center tw-py-5">
            No Results
          </div>
        </template>
        <template #loading-row>
          <td class="tw-py-3 tw-px-2">
            <base-skeleton-loader class="tw-h-4 tw-w-48 tw-mb-3" />
            <base-skeleton-loader class="tw-h-3 tw-w-100" />
          </td>
          <td class="tw-py-3 tw-px-4">
            <div class="tw-flex tw-space-x-2 tw-justify-center">
              <base-skeleton-loader class="tw-h-8 tw-w-20" v-for="key in 2" :key="`action-loader-cell-${key}`" />
            </div>
          </td>
        </template>
      </base-table>
    </base-content>
    <new-todo-item-type ref="createModal" :businessId="businessId" @typesUpdated="loadPage" />
    <edit-todo-item-type ref="editModal" :businessId="businessId" @typesUpdated="loadPage" />
    <delete-todo-item-type ref="deleteModal" :businessId="businessId" @typesUpdated="loadPage" />
  </div>
</template>
<script>
import { PlusIcon, EditIcon, TrashIcon } from "@/assets/svgs";
import NewTodoItemType from "@/views/business/activitytype/components/NewTodoItemType";
import EditTodoItemType from "@/views/business/activitytype/components/EditTodoItemType";
import DeleteTodoItemType from "@/views/business/activitytype/components/DeleteTodoItemType";

export default {
  name: "BusinessActivityTypes",
  props: {
    businessId: String,
  },
  components: {
    PlusIcon,
    EditIcon,
    TrashIcon,
    NewTodoItemType,
    EditTodoItemType,
    DeleteTodoItemType,
  },
  data() {
    return {
      isLoading: false,
      systemItems: [],
      customItems: [],
      fields: [{ title: "Activity Type", key: "activityType", thClass: "tw-w-0 tw-text-left" }, { title: "Actions", key: "actions", thClass: "tw-w-0 tw-text-center" }],
    };
  },
  computed: {
    breadcrumbs() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return [{ title: "Settings", onClick: () => this.$router.push(`/businesses/${this.businessId}/business`) }, { title: "Activity Types" }];
    },
  },

  watch: {
    skip() {
      this.loadPage();
    },
  },
  created() {
    this.loadPage();
  },
  methods: {
    loadPage() {
      this.isLoading = true;
      let url = `/businesses/${this.businessId}/todo/types`;

      this.$axios
        .get(url)
        .then((res) => {
          this.customItems = res.data.filter((x) => x.isSystemManaged === false).sort((a, b) => (a.label > b.label ? 1 : -1));
          this.systemItems = res.data.filter((x) => x.isSystemManaged === true).sort((a, b) => (a.label > b.label ? 1 : -1));
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = true;
          console.log(err);
          debugger;
        });
    },
    next() {
      this.skip += this.take;
    },
    previous() {
      this.skip -= this.take;
    },
    add() {
      this.$refs.createModal.show();
    },
    edit(item) {
      this.$refs.editModal.show(item);
    },
    del(item) {
      this.$refs.deleteModal.show(item);
    },
  },
};
</script>
<style scoped>
/* for mobile screens */
@media screen and (min-width: 768px) {
  .dummy-tw-margin {
    margin-left: -55px;
    margin-right: -55px;
    margin-top: -51px;
  }
}
</style>
